var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"header-nav"},[_c('ul',{staticClass:"nav-target-box"},_vm._l((Object.entries(_vm.navTargets)),function(ref){
var key = ref[0];
var val = ref[1];
return _c('li',{key:key,class:[
					'nav-target',
					'title-ttr',
					'text-color-pmr',
					{ active: key === _vm.curPage }
				],on:{"click":function($event){return _vm.changeCurPage(key)}}},[_vm._v(" "+_vm._s(val)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }